module.exports = __webpack_public_path__ + "static/nordic_2-dfa1bcfac4ead1da9c92bf5f5d7028dd.jpg";